var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFD",
    d: "M33.334 33.527h8.138c.173 0 .255 0 .268-.229.066-.834.066-1.673 0-2.509 0-.162-.08-.229-.255-.229H25.29c-.2 0-.254.067-.254.257v2.4c0 .31 0 .31.32.31h7.978Zm7.497-5.773a.264.264 0 0 0 0-.188 5.343 5.343 0 0 0-.484-.85 6.87 6.87 0 0 0-.99-1.255 3.293 3.293 0 0 0-.616-.607 9.593 9.593 0 0 0-4.016-2.05 9.908 9.908 0 0 0-2.275-.243h-7.188c-.2 0-.227.08-.227.257v4.788c0 .202 0 .256.254.256h15.446s.134-.027.16-.108h-.065.001Zm0 8.58a3.093 3.093 0 0 0-.684 0H25.304c-.2 0-.268 0-.268.27v4.68c0 .216 0 .27.268.27h6.853c.327.026.655.003.976-.066a10.16 10.16 0 0 0 2.906-.648c.339-.119.666-.273.976-.459h.093a8.73 8.73 0 0 0 3.735-3.788s.093-.204-.012-.258v-.002Zm-18.485 7.648v-7.459c0-.176 0-.202-.214-.202h-2.905c-.16 0-.227 0-.227-.216v-2.563h3.105c.174 0 .241 0 .241-.23v-2.535c0-.162 0-.202-.214-.202h-2.905c-.16 0-.227 0-.227-.216v-2.374c0-.148 0-.188.214-.188h2.878c.2 0 .254 0 .254-.256V20.27c0-.216 0-.27.268-.27h10.038c.729.03 1.452.11 2.168.243a13.02 13.02 0 0 1 4.19 1.565c.86.51 1.65 1.125 2.355 1.834.53.555 1.008 1.155 1.432 1.794.421.648.771 1.34 1.046 2.064a.349.349 0 0 0 .4.284h2.395c.308 0 .308 0 .321.297v2.212c0 .216-.08.27-.295.27h-1.847c-.187 0-.24 0-.227.243.073.822.073 1.646 0 2.468 0 .23 0 .256.255.256h2.114c.093.122 0 .243 0 .365.013.157.013.315 0 .472v1.632c0 .23-.067.297-.269.297h-2.53a.335.335 0 0 0-.388.257 10.789 10.789 0 0 1-2.81 4.128c-.456.412-.934.8-1.433 1.16-.536.31-1.057.633-1.606.89a14.39 14.39 0 0 1-3.16 1.011 16.26 16.26 0 0 1-3.131.256h-9.29v-.013l.004-.003Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDai);
export default __webpack_public_path__ + "static/media/vDai.791549a9ce2fa4272d780bca62076a20.svg";
export { ForwardRef as ReactComponent };